import { ChangeDetectionStrategy, Component, DestroyRef, Inject, inject } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { MDTask } from '@helpers/types/models';
import { exist } from '@campaign-portal/namespace/common/id';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ManualDippingService } from '../../manual-dipping/manual-dipping.service';

@Component({
	selector: 'app-clients-delete-dialog',
	templateUrl: './dialog.component.html',
	styleUrl: './dialog.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class ManualDippingDeleteDialogComponent {

	private readonly destroyRef = inject(DestroyRef);

	constructor(
		@Inject(DIALOG_DATA) public readonly data: { mdTask: MDTask<exist> },
		public readonly manualDippingService: ManualDippingService,
		private readonly dialogRef: DialogRef<boolean>
	) {
	}

	confirm(): void {
		this.manualDippingService.delete({ mdTaskID: this.data.mdTask.mdTaskID })
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((resp) => {
				if ( resp.data.mdTaskID ) {
					this.dialogRef.close(true);
				}
			});
	}

	close(): void {
		this.dialogRef.close(false);
	}
}
